// extracted by mini-css-extract-plugin
module.exports = {"tinyWidgets":"TinyWidgets_tinyWidgets__44cBT","container":"TinyWidgets_container__2u1ND","collapseButton":"TinyWidgets_collapseButton__3e1HB"};